import { LinearProgress } from '@mui/material';
import type { ComponentType, SuspenseProps } from 'react';
import { Suspense } from 'react';

/**
 * Wraps a component with Suspense and LinearProgress fallback if nothing was provided
 * @param WrappedComponent The component to wrap.
 * @param fallback The component to render while loading.
 * @returns Suspense wrapped component
 *
 * @example
 * const WrappedComponent = withSuspense(lazy(() => import("path/to/some/Component")));
 */
export function withSuspense<P extends object>(
  WrappedComponent: ComponentType<P>,
  fallback: SuspenseProps['fallback'] = null,
) {
  function ComponentWithSuspense(props: P) {
    const C = WrappedComponent as ComponentType<any>;
    return (
      <Suspense fallback={fallback ?? <LinearProgress />}>
        <C {...props} />
      </Suspense>
    );
  }

  return ComponentWithSuspense;
}
